import { Modal, ModalProps } from './modal';
import { FC, Suspense, lazy } from 'react';
import 'react18-json-view/src/style.css';

const JsonView = lazy(() => import('react18-json-view'));

export interface JsonViewModalProps extends Omit<ModalProps, 'children'> {
  data: unknown;
  collapsed?: number | boolean;
}

export const JsonViewModal: FC<JsonViewModalProps> = ({
  data,
  title = 'JSON View',
  size = 'lg',
  collapsed = false,
  ...modalProps
}) => (
  <Modal {...modalProps} title={title} size={size}>
    <div className="bg-light rounded p-4" style={{ maxHeight: '60vh', overflow: 'auto' }}>
      <Suspense fallback={<div className="text-muted">Loading...</div>}>
        <JsonView src={data} collapsed={collapsed} enableClipboard />
      </Suspense>
    </div>
  </Modal>
);
